export var Alignment = /*#__PURE__*/ function(Alignment) {
    Alignment["ALIGNMENT_UNKNOWN"] = "ALIGNMENT_UNKNOWN";
    Alignment["ALIGNMENT_START"] = "ALIGNMENT_START";
    Alignment["ALIGNMENT_CENTER"] = "ALIGNMENT_CENTER";
    Alignment["ALIGNMENT_END"] = "ALIGNMENT_END";
    return Alignment;
}({});
